import { render, staticRenderFns } from "./printSopModal.vue?vue&type=template&id=ddb47b20&"
import script from "./printSopModal.vue?vue&type=script&lang=js&"
export * from "./printSopModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports